/** Vehicle search sort keys — leaf module (no imports). */

export const VEHICLE_SEARCH_SORT = {
  RECOMMENDED: "recommended",
  NEWEST: "newest",
  LOWEST_PRICE: "lowest_price",
  HIGHEST_PRICE: "highest_price",
  LOWEST_MILEAGE: "lowest_mileage",
  NEWEST_YEAR: "newest_year",
  BEST_VALUE: "best_value",
  VERIFIED_DEALERS_FIRST: "verified_dealers_first",
  RECENTLY_CONFIRMED: "recently_confirmed",
};
